// Outline Style Plugin
import { createColorProperty } from "./helpers.js";
export default {
    id: 'outline',
    label: 'Outline',
    icon: 'Square',
    properties: {
        outlineWidth: {
            label: 'Width',
            type: 'select',
            options: ['0', '1', '2', '4', '8'],
            default: '2',
            toClass: (value) => value ? `outline-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^outline-(\d+)$/);
                return match ? match[1] : null;
            }
        },
        outlineColor: {
            label: 'Color',
            type: 'color',
            default: null,
            ...createColorProperty('outline', ['0', '1', '2', '4', '8', 'none', 'solid', 'dashed', 'dotted', 'double'])
        },
        outlineStyle: {
            label: 'Style',
            type: 'select',
            options: ['none', 'solid', 'dashed', 'dotted', 'double'],
            default: 'solid',
            toClass: (value) => value ? `outline-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^outline-(none|solid|dashed|dotted|double)$/);
                return match ? match[1] : null;
            }
        },
        outlineOffset: {
            label: 'Offset',
            type: 'select',
            options: ['0', '1', '2', '4', '8'],
            default: '2',
            toClass: (value) => value ? `outline-offset-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^outline-offset-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
